import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UiRichEditorComponent } from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

@Component({
  selector: 'app-rich-editor-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiRichEditorComponent, AppExampleSectionComponent],
  templateUrl: './rich-editor-doc.component.html',
  styleUrl: './rich-editor-doc.component.scss',
})
export class RichEditorDocComponent {
  protected readonly content = signal('');
  protected readonly isInvalid = signal(false);

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }
}
